// import node module libraries
// import node module libraries
// import node module libraries
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Col, Image, Row, Table } from 'react-bootstrap';
import {
	useFilters,
	useGlobalFilter,
	usePagination,
	useTable
} from 'react-table';

// import custom components
import GlobalFilter from 'components/elements/advance-table/GlobalFilter';
// import custom components
// import custom components
import Pagination from 'components/elements/advance-table/Pagination';

// import utility file
import EleveService from '../../../services/EleveService';
import { Avatar } from '../../../../elements/bootstrap/Avatar';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ElevesListItems = () => {
	const { id } = useParams();
	const [eleves, setEleves] = useState([]);

	useEffect(() => {
		const fetchEleves = async () => {
			try {
				const response = await EleveService.getAllEleves(parseInt(id));
				setEleves(response);
			} catch (error) {
				console.error('Error fetching eleves data', error);
			}
		};

		fetchEleves();
	}, [id]);

	const formatValue = (value, columnId) => {
		if (typeof value === 'string') {
			if (columnId === 'nom' && value) {
				return value.toUpperCase();
			} else if (
				columnId === 'genre' ||
				(columnId === 'statut_eleve' && value)
			) {
				return (
					value && value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
				);
			} else if (
				columnId === 'lieu_naissance' ||
				(columnId === 'prenom' && value)
			) {
				return value.replace(/[^-'\s]+/g, function (word) {
					return word.replace(/^./, function (first) {
						return first.toUpperCase();
					});
				});
			} else {
				return value;
			}
		}
		return value;
	};

	const getInitials = (eleve) => {
		const firstName = eleve.prenom ? eleve.prenom.charAt(0).toUpperCase() : '';
		const lastName = eleve.nom ? eleve.nom.charAt(0).toUpperCase() : '';
		return `${lastName} ${firstName}`;
	};
	const columns = useMemo(
		() => [
			{ accessor: 'id', Header: 'ID', show: false },
			{
				accessor: 'nom',
				Header: 'Nom',
				Cell: ({ value, row }) => {
					const initials = getInitials(row.original);
					const imageUrl = `${backendUrl}${row.original.photo}`;
					return (
						<div className="d-flex align-items-center">
							{row.original.photo ? (
								<Image
									src={imageUrl}
									alt=""
									className="rounded-circle avatar-md"
								/>
							) : (
								<Avatar
									type="initial"
									size="md"
									name={initials}
									className="rounded-circle"
									alt={initials}
								/>
							)}
							{value ? (
								<Link to={`/pedagogie/notes/${id}/eleves/${row.original.id}`}>
									<h5 className="mb-0 ms-2">{formatValue(value, 'nom')}</h5>
								</Link>
							) : null}
						</div>
					);
				}
			},

			{
				accessor: 'prenom',
				Header: 'Prenom',
				Cell: ({ value }) => <div>{formatValue(value, 'prenom')}</div>
			}
		],
		[]
	);

	const data = useMemo(() => {
		return eleves.map((eleve) => ({
			...eleve
		}));
	}, [eleves]);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		state,
		gotoPage,
		pageCount,
		prepareRow,
		setGlobalFilter
	} = useTable(
		{
			columns,
			data,
			initialState: {
				pageSize: 10,
				hiddenColumns: columns.map((column) => {
					if (column.show === false) return column.accessor || column.id;
					else return false;
				})
			}
		},
		useFilters,
		useGlobalFilter,
		usePagination
	);

	const { pageIndex, globalFilter } = state;
	return (
		<Fragment>
			<div className="overflow-hidden p-3">
				<Row className="justify-content-md-between mb-4 mb-xl-0 ">
					<Col xxl={3} lg={4} md={6} xs={12}>
						<GlobalFilter
							filter={globalFilter}
							setFilter={setGlobalFilter}
							placeholder="Rechercher un élève"
						/>
					</Col>
				</Row>
			</div>

			<Table
				hover
				responsive
				{...getTableProps()}
				className="table text-nowrap table-centered"
			>
				<thead className="table-light">
					{headerGroups.map((headerGroup) => (
						<tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column) => (
								<th {...column.getHeaderProps()}>{column.render('Header')}</th>
							))}
						</tr>
					))}
				</thead>
				<tbody {...getTableBodyProps()}>
					{page.map((row) => {
						prepareRow(row);
						return (
							<tr {...row.getRowProps()}>
								{row.cells.map((cell) => {
									return (
										<td {...cell.getCellProps()}>{cell.render('Cell')}</td>
									);
								})}
							</tr>
						);
					})}
				</tbody>
			</Table>

			<Pagination
				previousPage={previousPage}
				pageCount={pageCount}
				pageIndex={pageIndex}
				gotoPage={gotoPage}
				nextPage={nextPage}
			/>
		</Fragment>
	);
};

export default ElevesListItems;
